import { ModuleWithProviders, NgModule } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NSearch } from './df-search.config';

@NgModule()
export class DfSearchModule {
    static forRoot(config?: DeepPartial<NSearch.IModuleOptions>): ModuleWithProviders<DfSearchModule> {
        return {
            ngModule: DfSearchModule,
            providers: [
                {
                    provide: NSearch.OPTIONS,
                    useFactory: () => defaultsDeep(config, NSearch.DEFAULT_OPTIONS)
                }
            ]
        };
    }
}
